<button
  type="button"
  class="eventq-accent-checkbox"
  [class.eventq-accent-checkbox--checked]="checked()"
  (click)="toggle()"
>
  @if (checked()) {
    <img class="eventq-accent-checkbox__icon" [src]="tickIconSrc()" alt="" />
  } @else {
    <img
      class="eventq-accent-checkbox__icon"
      [src]="'/assets/events/icons/checkbox-unchecked.svg' | prefixUrl"
      alt=""
    />
  }
  <span class="eventq-accent-checkbox__label">{{ label() }}</span>
</button>
